import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-adsl-roundup',
  templateUrl: './adsl-roundup.component.html',
  styleUrls: ['./adsl-roundup.component.scss']
})
export class AdslRoundupComponent extends BaseComponent implements OnInit {
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  constructor(
    public userService: UserService,
    public translator: TranslateService,
    public cookieService: CookieService,
    public zone: NgZone,
    public route: ActivatedRoute,
    public titleService: Title,
  ) {
    super(userService, translator, cookieService, titleService);
  }
  seed: any = { code: '021', no: '', person_type: 'حقیقی', identification_no: '' };
  request_id: number;
  CRA_Code;
  captchaVerified: boolean = false;
  trying: boolean = false;
  craVerified = true;
  dslCenterId: number;
  successMsg: string;
  errorMsg: string;

  async ngOnInit() {
    const TCICenterCode = this.getParamValueQueryString('TCICentercode');
    const PhoneNumber = this.getParamValueQueryString('PhoneNumber');
    this.CRA_Code = this.getParamValueQueryString('CRA_Code');

    if (PhoneNumber && PhoneNumber.length === 10) {
      this.seed.code = `0${PhoneNumber.substring(0, 2)}`;
      this.seed.no = PhoneNumber.substring(2);
    }
    if (TCICenterCode && PhoneNumber && this.CRA_Code) {
      this.craVerified = false;
      this.userService.apiCall('api/user/verify_cra_link', { TCICenterCode, PhoneNumber, CRA_Code: this.CRA_Code }).subscribe((result: any) => {
        this.zone.run(() => {
          this.craVerified = true;
          this.dslCenterId = TCICenterCode;
        });
      }, error => {
        this.zone.run(() => {
          this.CRA_Code = undefined;
          this.craVerified = true;
          this.addRecaptchaScript();
        });
      });
    } else {
      this.addRecaptchaScript();
    }

  }

  getParamValueQueryString(paramName) {
    const url = window.location.href;
    let paramValue;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(paramName);
    }
    return paramValue;
  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    };

    (function (d, s, id, obj) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': '6LdMT-gUAAAAAD0SIi5t61Zb7ZKyQWKeJNb2-5bf',
      'hl': this.lang || 'fa',
      'expired-callback': () => {
        this.zone.run(() => {
          this.captchaVerified = false;
        });
      },
      'callback': (response) => {
        this.userService.confirmCaptcha(response).subscribe((result: any) => {
          this.zone.run(() => {
            this.captchaVerified = true;
          });
        }, error => {
          this.captchaVerified = true;
        });
      }
    });
  }

  onFormSubmit() {
    this.trying = true;
    this.successMsg = '';
    this.errorMsg = '';
    this.userService.apiCall('api/user/roundup_request',
      { username: `${this.seed.code}${this.seed.no}`, identification_no: this.seed.identification_no }).subscribe((result: any) => {
        this.zone.run(() => {
          this.trying = false;
        });
      }, error => {
        this.trying = false;
        console.error(error);
        this.errorMsg = 'ADSL_ROUNDUP_NOK_' + error.status;
      });
  }
}
